module.exports = __webpack_public_path__ + "img/icon_查看.675f9cef.svg";